import React from 'react';
import styles from './onboardingHero.module.css';

interface HeroTitleProps {
  lineOne: string;
  lineTwo: string;
}

const HeroTitle: React.FC<HeroTitleProps> = ({ lineOne, lineTwo }) => (
  <h1 className={styles.title}>
    {lineOne}
    <br />
    {lineTwo}
  </h1>
);

export default HeroTitle;
